import React, { useState, useEffect } from 'react';

// import IntlTelInput from 'react-intl-tel-input';
// import 'react-intl-tel-input/dist/main.css';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import './Input.phone.scss';
import AuditTrail from "../../services/interactions/audit.trail";

export default function InputPhone({ event, defaultCountry, parentError, id, phone, code, onChange, label, required }) {
    const [_isValid, _setIsValid] = useState(false);
    const [temp, setTemp] = useState('');
    const [empty, setEmpty] = useState(false);
    const [render, setRender] = useState(false);

    useEffect(() => {
        if(!temp && !!phone && !!code && render){
            console.log(`PH EFF: `, phone, code, temp);
            if(!empty) {
                let _phone = phone.replace('+', '');
                let full = `${code} ${_phone.replace(`+${code} `, '')}`;
                let isValid = required? _phone : !!_phone;
                _setIsValid(isValid);
                setTemp(full);
            }
        }
    }, [phone, code, temp, render]);

    useEffect(() => {
        if (!!defaultCountry) {
            setRender(true);
        }
    }, [defaultCountry]);

    const handleTempChange = (...values) => {
        const dialCode = '';
        const number = values.length && values[0]? values[0] : '';
        console.log(number);
        const completeNumber = number.replace(`+${dialCode} `, '');
        let isValid = required? number : !completeNumber || number;
        setEmpty(number==="");
        setTemp(number.replace(`+${dialCode} `, ''));
        _setIsValid(isValid);
        onChange({completeNumber, dialCode, isValid});
    }

    const handlePhoneChange = (...values) => {
        const dialCode = values[2].dialCode;
        const completeNumber = values[1].replace(`+${dialCode} `, ''); // "+1 442-382-5555"
        let isValid = required? values[0] : !completeNumber || values[0];
        AuditTrail.sendLog(event, {tag: 'input', event: 'onBlur', action: 'input phone number'});
        setTemp(values[3].replace(`+${dialCode} `, ''));
        _setIsValid(isValid);
        onChange({completeNumber, dialCode, isValid});
    }

    const handleFlagChange = (...value) => {
        const dialCode = value[1].dialCode;
        const completeNumber = value[0].replace(`+${dialCode} `, '');
        let isValid = required? value[3] : !completeNumber || value[3];
        AuditTrail.sendLog(event, {tag: 'select', event: 'onChange', action: 'input country change'});
        if(isValid){
            onChange({completeNumber, dialCode, isValid})
        }
        _setIsValid(isValid);
    }

    const showError = () => {
        return !!temp && !_isValid;
    }

    return (
        <div className={`PhoneComponent ${showError() ? 'invalid' : ''}`}>
            {
                label ?
            <label>{label}{required ? '*':''}</label>
                :''
            }
            {
                render?
                      <PhoneInput
                        country={defaultCountry}
                        value={temp}
                        onChange={handleTempChange}/> : ''
            }
        </div>
    )
}
